import React from 'react';

import { Icon } from '../../../common/components/Icon';
import { OrbitIcons } from '../../../common/constants.';

interface WizardNavProps {
  /** Whether the Back button should be shown */
  showBack: boolean;
  /** Whether the Next/Submit button should be disabled */
  nextDisabled: boolean;
  /** Whether we're on the final step */
  isFinalStep: boolean;
  /** Whether the wizard is currently submitting/processing */
  isSubmitting?: boolean;
  /** Custom label for the next button */
  nextLabel?: string;
  /** Called when Back is clicked */
  onBack: () => void;
  /** Called when Next/Submit is clicked */
  onNext: () => void;
  /** Called when Cancel is clicked */
  onCancel: () => void;
}

const WizardNav: React.FC<WizardNavProps> = ({
  showBack,
  nextDisabled,
  isFinalStep,
  isSubmitting = false,
  nextLabel,
  onBack,
  onNext,
  onCancel,
}) => {
  const defaultNextLabel = isFinalStep ? 'Crear Cuenta' : 'Siguiente';
  const buttonLabel = isSubmitting ? 'Procesando...' : nextLabel || defaultNextLabel;

  return (
    <footer className="shrink-0 flex items-center justify-between px-6 py-4 bg-white border-t border-gray-200">
      {/* Left side - Cancel */}
      <button
        type="button"
        onClick={onCancel}
        disabled={isSubmitting}
        className="hover:bg-gray-100 hover:text-gray-800 disabled:cursor-not-allowed disabled:opacity-50 px-4 py-2 text-sm font-medium text-gray-600 rounded-md"
      >
        Cancelar
      </button>

      {/* Right side - Back & Next */}
      <div className="flex items-center gap-3">
        {showBack && (
          <button
            type="button"
            onClick={onBack}
            disabled={isSubmitting}
            className="hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50 flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md"
          >
            <Icon name={OrbitIcons.ChevronLeft} size={16} />
            Anterior
          </button>
        )}

        <button
          type="button"
          onClick={onNext}
          disabled={nextDisabled || isSubmitting}
          className="hover:bg-blue-700 disabled:cursor-not-allowed disabled:bg-blue-400 flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md"
        >
          {isSubmitting ? (
            <>
              <span className="animate-spin">
                <Icon name={OrbitIcons.Clock} size={16} />
              </span>
              {buttonLabel}
            </>
          ) : (
            <>
              {buttonLabel}
              {!isFinalStep && <Icon name={OrbitIcons.ChevronRight} size={16} />}
            </>
          )}
        </button>
      </div>
    </footer>
  );
};

export default WizardNav;
